import { createAction, props } from '@ngrx/store';
import {
  AppLanguage,
  Breadcrumbs,
  GeneralDataDTO,
  GetPageActionData,
  HomePage,
  CmsPage,
  PageBase,
  UserRole,
  SearchResultPlugin,
  GuidelineDTO,
  StrategyDTO,
  LoadSearchPageSuccessData,
  ExportGuidelinesPayload,
} from '../models';
import { ContactState } from './contact/contact.reducer';

//#region general
export const LoadGeneralData = createAction(
  '[General Data] load',
  props<{ language: AppLanguage }>(),
);
export const LoadGeneralDataSuccess = createAction(
  '[General Data] loaded',
  props<{ language: AppLanguage; data: GeneralDataDTO }>(),
);

export const SetRole = createAction('[Role] set', props<{ role: UserRole | null }>());
//#endregion

//#region search
export const LoadSearchPage = createAction('[Search] load', props<{ query?: string; }>());
export const LoadSearchPageSuccess = createAction('[Search] loaded', props<LoadSearchPageSuccessData>());

export const SubmitSearch = createAction('[Search] submit', props<{ query: string }>());
export const SubmitSearchSuccess = createAction(
  '[Search] submit [Success]',
  props<{ query: string; language: AppLanguage; message?: string; results?: SearchResultPlugin[] }>(),
);
//#endregion

//#region breadcrumbs
export const SetBreadcrumbs = createAction(
  '[Breadcrumbs] set',
  props<{ breadcrumbs: Breadcrumbs }>(),
);
//#endregion

//#region pages
export const LoadPage = createAction('[Page] load', props<Omit<GetPageActionData, 'language'>>());
export const LoadedHomePage = createAction(
  '[Page] loaded [Home]',
  props<{ request: GetPageActionData; page: HomePage }>(),
);
export const LoadedCmsPage = createAction(
  '[CMS Page] loaded',
  props<{ request: GetPageActionData; page: CmsPage }>(),
);
//#endregion

//#region contact
export const LoadContactPage = createAction('[Contact page] load');
export const LoadContactPageSuccess = createAction(
  '[Contact page] loaded',
  props<{ page: PageBase & ContactState }>(),
);
export const SubmitContactForm = createAction(
  '[Contact form] submit',
  props<{
    formData: FormData;
  }>(),
);
export const ProcessedContactForm = createAction('[Contact form] processed');
export const ProcessContactFormError = createAction(
  '[Contact form] could not process',
  props<{ error: { message: string } }>(),
);
//#endregion

//#region customize guidelines
export const ToggleGuidelineSelection = createAction(
  '[Guidelines] Toggle Selection',
  props<{ id: string }>(),
);
export const LoadGuidelines = createAction(
  '[Guidelines] Loaded Guidelines',
  props<{ strategies: StrategyDTO[]; presets: { id: string; filter: string; name: string; }[]; categories: { id: string; filter: string; name: string; }[] }>()
);
// Filtering
export const SetGuidelinesMultiSelectFilter = createAction(
  '[Guidelines] Set MultiSelect Filter',
  props<{ filterType: keyof GuidelineDTO; selectedValues: any[] }>(),
);
export const ResetGuidelinesFilters = createAction('[Guidelines] Reset all filters');

export const ExportGuidelines = createAction('[Guidelines] Export selected', props<ExportGuidelinesPayload>());

// UI state for Customize Guidelines (open accordion, focus row)
export const SetGuidelinesUi = createAction(
  '[Guidelines/UI] Set UI state',
  props<{ openStrategyId: string | null; focusGuidelineId: string | null }>()
);
export const ClearGuidelinesUi = createAction('[Guidelines/UI] Clear UI state');
//#endregion

//#region Privacy - and Cookies Policy
export const LoadPrivacyAndCookies = createAction('[Privacy - and Cookies Policy] load', props<{ metaUrl: 'privacy-policy' | 'cookie-policy'; }>());
export const LoadPrivacyAndCookiesSuccess = createAction(
  '[Privacy - and Cookies Policy] loaded',
  props<{ page: PageBase }>(),
);

//#endregion

export const ApiError = createAction('[API Error]', props<{ error: { message: string } | any }>());
